import { render, staticRenderFns } from "./UpdateBasicPointSettings.vue?vue&type=template&id=0f002dd4&scoped=true&"
import script from "./UpdateBasicPointSettings.vue?vue&type=script&lang=js&"
export * from "./UpdateBasicPointSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f002dd4",
  null
  
)

export default component.exports